import { render } from "./VabeneCustomerList.vue?vue&type=template&id=911ec1fc&scoped=true&ts=true"
import script from "./VabeneCustomerList.vue?vue&type=script&lang=ts"
export * from "./VabeneCustomerList.vue?vue&type=script&lang=ts"

import "./VabeneCustomerList.vue?vue&type=style&index=0&id=911ec1fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911ec1fc"]])

export default __exports__